import { render, staticRenderFns } from "./SystemCategoryIcon.vue?vue&type=template&id=06249018&scoped=true"
import script from "./SystemCategoryIcon.vue?vue&type=script&lang=ts"
export * from "./SystemCategoryIcon.vue?vue&type=script&lang=ts"
import style0 from "./SystemCategoryIcon.vue?vue&type=style&index=0&id=06249018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06249018",
  null
  
)

export default component.exports